export default "__VITE_ASSET__2MfXMdJm__";